import React, { useState } from 'react'
import { FaChevronRight } from 'react-icons/fa'
import useTranslation from '../useTranslation'
import './Scorecard.scss'
import oversToBalls from '../util/oversToBalls'

export default function Scorecard({ scorecard, teams, partnerships, currentBattingTeam, displayInnings, isHundred }) {
    const [ expandedRow ] = useState(null);

    const Batter = useTranslation('Batter')
    const Bowler = useTranslation('Bowler')
    const R = useTranslation('R')
    const B = useTranslation('B')
    const a4s = useTranslation('4s')
    const a6s = useTranslation('6s')
    const SR = useTranslation('SR')
    const Extras = useTranslation('Extras')
    const NB = useTranslation('NB')
    const W = useTranslation('W')
    const LB = useTranslation('LB')
    const Overs = useTranslation('Overs')
    const Balls = useTranslation('Balls')
    const Runs = useTranslation('Runs')
    const Wickets = useTranslation('Wickets')
    const Wides = useTranslation('Wides')

    if (! teams || ! teams.find(i => i.name === currentBattingTeam)) {
        return (
            <div className="scorecard">
                Waiting for teams data
            </div>
        )
    }

    const { inns1, inns2, inns3, inns4 } = scorecard || {};

    let batting, bowling, extras;

    let fow = [];

    // TODO: Add FOW for all innings
    switch (displayInnings) {
        case 1:
            if (inns1) {
                batting = inns1.batting;
                bowling = inns1.bowling;
                extras = inns1.extras;
                if (partnerships && partnerships.fow.inns1) {
                    partnerships.fow.inns1.forEach(fall => {
                        if (fall.ovs === "") return;
                        if (isHundred) {
                            fow.push(`${fall.runs}/${fall.wkt} (${fall.dismissed}, ${oversToBalls(fall.ovs)} balls)`);
                        } else {
                            fow.push(`${fall.runs}/${fall.wkt} (${fall.dismissed}, ${fall.ovs} ovs)`);
                        }
                    })
                }
            }
            break;
        case 2:
            if (inns2) {
                batting = inns2.batting;
                bowling = inns2.bowling;
                extras = inns2.extras;
                if (partnerships && partnerships.fow.inns2) {
                    partnerships.fow.inns2.forEach(fall => {
                        if (fall.ovs === "") return;
                        if (isHundred) {
                            fow.push(`${fall.runs}/${fall.wkt} (${fall.dismissed}, ${oversToBalls(fall.ovs)} balls)`);
                        } else {
                            fow.push(`${fall.runs}/${fall.wkt} (${fall.dismissed}, ${fall.ovs} ovs)`);
                        }
                    })
                }
            }
            break;
        case 3:
            if (inns3) {
                batting = inns3.batting;
                bowling = inns3.bowling;
                extras = inns3.extras;
                if (partnerships && partnerships.fow.inns3) {
                    partnerships.fow.inns3.forEach(fall => {
                        if (fall.ovs === "") return;
                        if (isHundred) {
                            fow.push(`${fall.runs}/${fall.wkt} (${fall.dismissed}, ${oversToBalls(fall.ovs)} balls)`);
                        } else {
                            fow.push(`${fall.runs}/${fall.wkt} (${fall.dismissed}, ${fall.ovs} ovs)`);
                        }
                    })
                }
            }
            break;
        case 4:
            if (inns4) {
                batting = inns4.batting;
                bowling = inns4.bowling;
                extras = inns4.extras;
                if (partnerships && partnerships.fow.inns4) {
                    partnerships.fow.inns4.forEach(fall => {
                        if (fall.ovs === "") return;
                        if (isHundred) {
                            fow.push(`${fall.runs}/${fall.wkt} (${fall.dismissed}, ${oversToBalls(fall.ovs)} balls)`);
                        } else {
                            fow.push(`${fall.runs}/${fall.wkt} (${fall.dismissed}, ${fall.ovs} ovs)`);
                        }
                    })
                }
            }
            break;
        default:
            return (
                <div className="scorecard">
                    Innings yet to start
                </div>
            );
    }

    const { nb, wd, lb, b, p } = extras || {};

    if (! batting || ! bowling) {
        return (
            <div className="scorecard">
                Innings yet to start
            </div>
        );
    }

    let totalRuns = 0;

    batting.forEach(batter => {
        totalRuns += Number(batter.runs);
    })

    totalRuns += (nb + wd + lb + b + p);

    return (
        <div className="scorecard">
            <div className="batting-table">
                <div className="batting-table-header">
                    <div>{Batter}</div>
                    <div>{R}</div>
                    <div>{B}</div>
                    <div>{a4s}</div>
                    <div>{a6s}</div>
                    <div>{SR}</div>
                </div>
                { batting.map((batter, index) => {

                    if (! batter.name) return null;

                    const dismissedBy = batter.status.split(',')[1];
                    const status = batter.status.split(',')[0];

                    return (
                        <div
                            className="batting-table-row"
                            key={index}
                            // onClick={ () => {
                            //     if (batter.status === 'Not Out') {
                            //         return;
                            //     }
                            //     handleRowClicked(index)}
                            // }
                        >
                            <div className="batting-table-row-primary">
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>{batter.name}<div className="dismissed-by">{ status } { dismissedBy }</div></div>
                                    { batter.status !== 'Not Out' &&
                                        <FaChevronRight
                                            style={{ marginRight: '10px', transition: 'transform 0.1s ease-in-out', transform: expandedRow === index ? 'rotate(90deg)' : '' }}
                                            color='#fff'
                                        />
                                    }
                                </div>
                                <div>{batter.runs}</div>
                                <div>{batter.balls}</div>
                                <div>{batter.fours}</div>
                                <div>{batter.sixes}</div>
                                <div>{batter.balls > 0 && (batter.runs / batter.balls * 100).toFixed()}</div>
                            </div>
                            { expandedRow === index && (
                                <div className="batting-table-row-expanded">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                                </div>
                            )}
                        </div>
                    )
                })}
                <div className="batting-table-extras batting-table-row">
                    <div>{Extras}</div>
                    <div>({NB} {nb}, {W} {wd}, {LB} {lb}, {B} {b}{p ? `, P ${p}` : null})</div>
                    <div>{nb + wd + lb}</div>
                </div>
                <div className="batting-table-totals">
                    <div>TOTAL</div>
                    <div className="total-runs">{totalRuns}</div>
                </div>
                { fow.length ? (
                    <div className="fall-of-wickets">
                        <div style={{ fontSize: '16px', marginBottom: '10px', fontWeight: 'bold' }}>Fall of Wickets</div>
                        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                            { fow.map((fall, index) => {
                                return (
                                    <div style={{ marginRight: '2px' }} key={index}>
                                        {fall}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                ) : null }
            </div>
            <div className="bowling-table">
                <div className="bowling-table-header">
                    <div>{Bowler}</div>
                    <div>{isHundred ? Balls : Overs}</div>
                    <div>{Runs}</div>
                    <div>{Wickets}</div>
                    <div>{NB}</div>
                    <div>{Wides}</div>
                </div>
                { bowling.map((bowler, index) => (
                    <div className="bowling-table-row" key={index}>
                        <div>{bowler.name}</div>
                        <div>{bowler.overs}</div>
                        <div>{bowler.runs}</div>
                        <div>{bowler.wickets}</div>
                        <div>{bowler.nb}</div>
                        <div>{bowler.wd}</div>
                    </div>
                ))}
            </div>
        </div>
    )
}
